import React from 'react'
import { prettyDate, authorInfo } from 'scripts/lib/utils'
import { PaddedAssociations, GenerateLink } from 'scripts/helpers/AppHelper'

const MobileMeta = ({author, date, category, customOnClick}) => {
  if (!author) return null
  const dateLocale = true
  const authorName = authorInfo(author)
  const authorLinkProps = {slug: author.id, type: 'author', title: `Articles by ${authorName}`, element: authorName}
  return (
    <div className="mid-small">
      <div className="clearfix">
        <div className="info-emphasis left">
          <div className="meta-container"><PaddedAssociations
            type='category'
            data={category}
            containerClass='tags-container hide-on-small'
            assocClass='badges tags'
            limit={1}
            customOnClick={customOnClick}
          />
          <div className="date-time">{prettyDate(date, dateLocale)}</div>
          </div>
        </div>
        <div className="info-emphasis right">
          <span>by</span> <span className="strong emphasis base-size">
            <GenerateLink {...authorLinkProps} />
          </span>
        </div>
      </div>
    </div>
  )
}

export default MobileMeta



// WEBPACK FOOTER //
// ./assets/js/components/article/MobileMeta.jsx